<template>
          <v-dialog v-model="showDialog" persistent scrollable max-width="600">
          <v-card>
						<v-card-title> 
							<span class="col-12 no-break-word">Ayuda de '{{titulo}}'</span>          
						</v-card-title>
						<!--<v-card-title v-if="titulo" class="text-body-1">
							Ejemplo de '{{titulo}}'
						</v-card-title>-->
            <!--<v-card-title class="headline">Ejemplo</v-card-title>-->
            <v-card-text class="pt-1 pb-0">
							<v-row>
								<v-col cols="12" v-if="textoAyuda" v-html="textoAyuda">
								{{ textoAyuda }}
								</v-col>
								<v-col v-if="imagen">
									<v-img contain :src="imagen"/>
								</v-col>
							</v-row>
							</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
								color="rgb(18, 77, 145)"
								text
								class="text-decoration-underline"
								@click="showDialog = false"
							>
								Cerrar
							</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>

<script>
 
export default {
	name: 'ImageDialog',
	data() {
    return { 
			titulo: null,
			imagen: null,
			textoAyuda: null,
			showDialog: false
		}
  },  
  methods: {
    open(titulo, imagen, textoAyuda) {
			this.titulo = titulo;
      this.imagen = imagen;
      this.textoAyuda = textoAyuda;
      this.showDialog = true;
    }
	},
}
</script>